import { Navigate, Route, Routes, useLocation } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminUsersPage } from "@/features/admin/users";
import { CasesPage } from "@/features/cases";
import { CaseDetailPage } from "@/features/cases/detail";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { SignupPage } from "@/features/signup";
import { VerifyEmailPage } from "@/features/verify-email";

/** Redirects legacy /cases links to "/" while keeping any filter query params. */
function RedirectToLibrary() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: "/", search }} replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route element={<ProtectedRoute />}>
        {/* The Cases Library is the app's home page. */}
        <Route path="/" element={<CasesPage />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/cases" element={<RedirectToLibrary />} />
        <Route path="/cases/:id" element={<CaseDetailPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
